<template>
  <div>
    <search-cpe-inventory-statistic @submit="submitSearch" />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="cpe_model_id"
    >
      <span slot="cpe_model_name" slot-scope="text, record">
        <template v-if="record.display_model && record.display_model !== text">
          {{ text }}（对外：{{ record.display_model }}）
        </template>
        <template v-else>
          {{ text }}
        </template>
      </span>

      <span slot="is_alarm" slot-scope="text">
        {{ text ? '是' : '否' }}
      </span>

      <span slot="alarm_value" slot-scope="text, record">
        {{ record.is_alarm ? text : '-' }}
      </span>

      <span slot="effective" slot-scope="text">
        {{ text ? '有效' : '无效' }}
      </span>

      <span slot="actions" slot-scope="text, record">
        <a
          v-if="isHasSetAlarmPermission"
          @click="showSetAlarmModal(record.cpe_model_id, record.is_alarm, record.alarm_type, record.alarm_value)"
        >告警配置</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <set-alarm
      v-if="isShowSetAlarmModal"
      :visible.sync="isShowSetAlarmModal"
      :cpe-model-id="settingCpeModelId"
      :is-alarm="isAlarm"
      :alarm-type="alarmType"
      :alarm-value="alarmValue"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findCpeInventoryStatistics } from '@/api/cpe_inventory'
import Pagination from '@/components/Pagination'
import SearchCpeInventoryStatistic from '@/views/cpe_inventories/statistics/Search'

export default {
  name: 'CpeInventoryStatisticList',
  components: {
    Pagination,
    SearchCpeInventoryStatistic,
    SetAlarm: () => import('@/views/cpe_inventories/statistics/SetAlarm')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowSetAlarmModal: false,
      settingCpeModelId: 0,
      isAlarm: false,
      alarmType: 1,
      alarmValue: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        { title: '供应商', dataIndex: 'cpe_supplier_name', width: 160 },
        { title: 'CPE型号', dataIndex: 'cpe_model_name', width: 220, scopedSlots: { customRender: 'cpe_model_name' }},
        { title: '库存数量', dataIndex: 'inventory_count', width: 120 },
        { title: '是否告警', dataIndex: 'is_alarm', width: 100, scopedSlots: { customRender: 'is_alarm' }},
        { title: '告警数量', dataIndex: 'alarm_value', width: 120, scopedSlots: { customRender: 'alarm_value' }},
        { title: '有效性', dataIndex: 'effective', width: 100, scopedSlots: { customRender: 'effective' }},
        { title: '操作', dataIndex: 'actions', width: 120, scopedSlots: { customRender: 'actions' }}
      ]
    },

    isHasSetAlarmPermission() {
      return hasPermission('cpe_inventory_statistics/set_alarm') || hasPermission('cpe_inventories')
    }
  },
  methods: {
    showSetAlarmModal(cpeModelId, isAlarm, alarmType, alarmValue) {
      this.settingCpeModelId = cpeModelId
      this.isAlarm = isAlarm

      if (isAlarm) {
        this.alarmType = alarmType || 1
        this.alarmValue = alarmValue
      } else {
        this.alarmType = 1
        this.alarmValue = 0
      }

      this.isShowSetAlarmModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findCpeInventoryStatistics(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
